const OSDTooltips = {
  FullPage: "Vollbildmodus",
  Home: "Vollständige Seite an Fenstergröße anpassen",
  ZoomIn: "Vergrößen",
  ZoomOut: "Verkleinen",
  NextPage: "Nächste Seite",
  PreviousPage: "Vorherige Seite",
  RotateLeft: "Nach rechts drehen",
  RotateRight: "Nach links drehen"
};

const THEMEN_COLORS = {
  'Thema 1': '#690000',
  'Thema 2': '#689b5e',
  'Thema 3': '#c73c33',
  'Thema 3a': '#51685a',
  'Thema 4': '#dfc963',
  'Thema 5': '#214d78',
  'Thema 6': '#350021',
  'Thema 7': '#763f18',
  'Thema iii': '#6e66a6',
  'Thema 9': '#000000',
  'Thema 10': '#335a9b',
  'Thema 11': '#12578b',
  'Thema 12': '#774725',
  'Thema 13': '#65b095',
  'Thema 14': '#737069',
  'Thema 15': '#0a0019',
  'Thema 16': '#004524',
  'Thema 17': '#70212e',
  'Thema 17a': '#f9fcac',
  'Thema 18': '#d77427',
  'Thema 18a': '#d7852f',
};

export { SIDEBAR_MODEL, OSDTooltips, THEMEN_COLORS };



// WEBPACK FOOTER //
// ./src/store/datamodel/constants.js